import { rem, size, transparentize } from 'polished';
import styled from 'styled-components';

export const AccountBarStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${rem(20)};
  padding-bottom: ${rem(12)};
  font-weight: bold;
  border-bottom: 1px solid
    ${({ theme }) => transparentize(0.5, theme.colors.palette.black)};
`;

export const Button = styled.a`
  display: block;
  padding: 0;
  background: none;
  border: 0;
  cursor: pointer;

  svg {
    ${size(rem(22))};

    display: block;
    color: ${({ theme }) => theme.colors.palette.black};
  }
`;
